import all from '../intl/all';
import Cookies from 'universal-cookie';
import { getBrowserDataFromUA } from './modules/browser';
import { getPageSizeFromCookie } from '../utils/pagination';

const cookie = new Cookies();

const DEFAULT_ITEMS_TO_SHOW = 24;

const getInitialData = ({
    basename = '',
    config: configDefaults = {},
    req = { cookies: [], headers: [], hostname: '', url: '' },
    whiteLabelInfo = false,
}) => {
    // check the cookie for a valid token
    const referrer = req.headers.referer || '';
    const touchDate = new Date().getTime();
    const disableModalForTesting = req.url.includes('hideForTesting') || req.url.includes('/console/');

    var whiteLabel = {
        hostname: req.hostname,
        isWhiteLabel: false,
        logo: 'https://p1.liveauctioneers.com/dist/images/logo.svg',
        sellerId: 0,
    };

    const pageSize =
        getPageSizeFromCookie(req.cookies['pagination-page-size']) ||
        getPageSizeFromCookie(cookie.get('pagination-page-size')) ||
        DEFAULT_ITEMS_TO_SHOW;

    if (whiteLabelInfo) {
        const { name: sellerName, sellerId, website, logoId } = whiteLabelInfo;
        const siteNameMatch = (website || '').match(/^(?:https?:\/\/)?(?:[w]{3}\.)?(.*)$/);
        const siteName = siteNameMatch && siteNameMatch[1].length > 0 ? siteNameMatch[1].replace(/\/+$/, '') : '';

        whiteLabel = {
            hostname: req.hostname,
            isWhiteLabel: true,
            logo:
                !logoId || logoId === ''
                    ? null
                    : `https://images.liveauctioneers.com/houses/logos/lg/${logoId}_large.jpg?auto=webp&format=pjpg`,
            name: sellerName,
            sellerId,
            siteName,
            siteUrl: website || '',
        };
    }

    const intl = {
        defaultLocale: 'en',
        locale: 'en',
        messages: all['en'],
    };
    if (basename === '/en-gb') {
        intl.defaultLocale = 'en-gb';
        intl.locale = 'en-gb';
        intl.messages = { ...all['en'], ...all['en-gb'] };
    }

    const config = {
        ...configDefaults,
        baseUrl: `${configDefaults.baseUrl}${basename}`,
        wwwBaseUrl: configDefaults.baseUrl,
    };

    let width = 1024;
    const { mobile } = getBrowserDataFromUA(req.headers['user-agent'] ? req.headers['user-agent'] : '');
    if (Boolean(mobile)) {
        if (mobile === 'phone') {
            width = 500;
        } else if (mobile === 'tablet') {
            width = 768;
        }
    }

    return {
        analytics: {
            referrer,
            touchDate,
        },
        autoPopModal: {
            dateLastShown: '',
            disableModalForTesting,
            hasLoggedInBefore: false,
        },
        browser: {
            deviceType: 'computer',
            microsoftBrowser: false,
            mobile: '',
            name: '',
        },
        config,
        currency: req.currency,
        intl,
        pagination: {
            pageSize,
        },
        user: { userData: {} },
        userVariantTest: req.userVariantTest || { byId: {}, loaded: 0 },
        whiteLabel,
        windowSize: { width: width },
    };
};

export default getInitialData;
